export class NotificationOptions {}
